import LoginOrganizationForm from './LoginOrganizationForm'

export default LoginOrganizationForm



// WEBPACK FOOTER //
// ./src/views/Login/components/LoginOrganizationForm/index.js